import React from 'react'
import { Main } from '../Components/CoffeeComponent/Main'

export const Coffee = () => {
  return (
    <>
    <Main />
    </>
  )
}
